import { render, staticRenderFns } from "./LicenseModeChooser.vue?vue&type=template&id=671973c4&scoped=true"
import script from "./LicenseModeChooser.vue?vue&type=script&lang=js"
export * from "./LicenseModeChooser.vue?vue&type=script&lang=js"
import style0 from "./LicenseModeChooser.vue?vue&type=style&index=0&id=671973c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671973c4",
  null
  
)

export default component.exports